export * from '@primeuix/themes/lara/datatable';
export { default } from '@primeuix/themes/lara/datatable';
